export default "__VITE_ASSET__CudHgKSB__"